import axios from "axios";

// Thin client — the actual Farvision calls (and apikey) live server-side in
// SALES-APP-BACKEND-NODE-API's cppayments/farvisionBrokerChangeService.js,
// reached via the same cpPaymentRoutes router CpPayout.jsx already calls.
// This file exists purely so LeadSourceChange.jsx's orchestration code
// (payment gate → delete → create → rollback) didn't need to change.
const BASE_URL = `${process.env.REACT_APP_PAYMENT_LINK_URL}cp-payment/broker-change`;

async function postToBackend(path, body, fallbackMessage) {
  try {
    const response = await axios.post(`${BASE_URL}${path}`, body);
    if (!response.data?.success) {
      throw new Error(response.data?.message || fallbackMessage);
    }
    return response.data.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || err.message || fallbackMessage);
  }
}

/**
 * FETCH — current brokerage line item(s) Farvision holds for a booking.
 * Returns { booking, items } — items may be empty if the booking has never
 * had a brokerage entry.
 */
export const fetchBookingBrokerageData = (bookingId, buId) =>
  postToBackend("/fetch", { bookingId, buId }, "Failed to fetch Farvision brokerage data.");

/**
 * DELETE — mark every current brokerage line item on this booking as
 * deleted in Farvision. Pass `preFetched` when this is followed by
 * createFarvisionBrokerLine for the same booking (CP→CP).
 */
export const deleteFarvisionBrokerLines = (bookingId, buId, preFetched = null) =>
  postToBackend("/delete", { bookingId, buId, preFetched }, "Failed to delete the Farvision brokerage line.");

/**
 * ROLLBACK — re-inserts brokerage line item(s) previously removed by
 * deleteFarvisionBrokerLines, from the same preFetched snapshot. Used when
 * a CP→CP create fails after the old CP's line has already been deleted.
 */
export const restoreFarvisionBrokerLines = (preFetched) =>
  postToBackend("/restore", { preFetched }, "Failed to restore the Farvision brokerage line.");

/**
 * CREATE — a brand-new brokerage line for the incoming CP (Direct→CP, and
 * the new-CP half of CP→CP).
 */
export const createFarvisionBrokerLine = ({
  bookingId,
  buId,
  newCpLedgerId,
  brokeragePercentage,
  agreementValue,
  preFetched = null,
}) =>
  postToBackend(
    "/create",
    { bookingId, buId, newCpLedgerId, brokeragePercentage, agreementValue, preFetched },
    "Failed to create the Farvision brokerage line."
  );
